import { render, staticRenderFns } from "./topMargin-editor.vue?vue&type=template&id=1e4fa6a7&scoped=true"
import script from "./topMargin-editor.vue?vue&type=script&lang=js"
export * from "./topMargin-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fa6a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4fa6a7')) {
      api.createRecord('1e4fa6a7', component.options)
    } else {
      api.reload('1e4fa6a7', component.options)
    }
    module.hot.accept("./topMargin-editor.vue?vue&type=template&id=1e4fa6a7&scoped=true", function () {
      api.rerender('1e4fa6a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid/topMargin-editor.vue"
export default component.exports